import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import { i18n } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import churchLogos from '../ChurchLogos'
import churchLinks from '../components/ChurchLinks'

const imageCss = css`
  width: 170px;
`

export default function MinChurchLogo({ ...props }) {
  const { t } = useTranslation()
  const churchLogo = churchLogos(i18n.language)
  const churchLink = churchLinks[i18n.language] ? churchLinks[i18n.language] : churchLinks.en

  return (
    // duplicate link, preventing screen readers from getting the link twice
    <Link
      aria-hidden="true"
      tabIndex="-1"
      to={churchLink}
      title={t(
        'footer.service-by-church.text',
        'A service provided by The Church of Jesus Christ of Latter-day Saints'
      )}
      linkName={churchLink}
      external
      {...props}
    >
      <img
        className={imageCss}
        src={churchLogo}
        alt={t(
          'footer.service-by-church.text',
          'A service provided by The Church of Jesus Christ of Latter-day Saints'
        )}
      />
    </Link>
  )
}
